import LoginPage from "../components/page-login";
import MainPage from "../components/page-main";
import BalancePage from "../components/page-balance";
import BonusPage from "../components/page-bonus";
import BonusSpend from "../components/page-bonus-spend";
import NotificationsPage from "../components/page-notifications";
import ChatPage from "../components/page-chat";
import Documents from "../components/page-documents";
import Camera from "../components/page-videocamera";
import SmartHouse from "../components/page-smart-house";
import MyServices from "../components/page-my-tariffs";
import PageProfile from "../components/page-profile";
import InternetTariffs from "../components/page-internet-tariffs";
import PageService from "../components/page-service";
import PageRecomend from "../components/page-recomend";
import PageRecommend from "../components/page-recommend";
import PageRecomendTerm from "../components/page-recomend-term";
import PageRecomendQrcode from "../components/page-recomend-qrcode";
import PageRecomendUrl from "../components/page-recomend-url";
import PageAutopayment from "../components/page-autopayment";
import {createWebHistory} from "vue-router";
import {createRouter} from "vue-router";
import {ensureActiveAccount} from "../utils/multi-account";

const routes = [
    {
        path: "/",
        name: "Main",
        meta: {auth: true,},
        component: MainPage,
    },
    {
        path: "/login",
        name: "Login",
        meta: {auth: false,},
        component: LoginPage,
    },
    {
        path: "/balance",
        name: "Balance",
        meta: {auth: true,},
        component: BalancePage,
    },
    {
        path: "/bonusspend",
        name: "BonusSpend",
        meta: {auth: true},
        component: BonusSpend,
    },
    {
        path: "/bonus",
        name: "Bonus",
        meta: {auth: true,},
        component: BonusPage,
    },	
    {
        path: "/notifications",
        name: "Notifications",
        meta: {auth: true,},
        component: NotificationsPage,
    },
    {
        path: "/chat",
        name: "Chat",
        meta: {auth: true,},
        component: ChatPage,
    },
    {
        path: "/documents",
        name: "Documents",
        meta: {auth: true,},
        component: Documents,
    },
    {
        path: "/camera",
        name: "Camera",
        meta: {auth: true,},
        component: Camera,
    },
    {
        path: "/smart-house",
        name: "Smart House",
        meta: {auth: true,},
        component: SmartHouse,
    },
    {
        path: "/my-tariffs",
        name: "My Tariffs",
        meta: {auth: true,},
        component: MyServices,
    },
    {
        path: "/profile",
        name: "Profile",
        meta: {auth: true},
        component: PageProfile,
    },
    {
        path: "/tariffs",
        name: "Tariffs",
        meta: {auth: true},
        component: InternetTariffs,
    },
    {
        path: "/service",
        name: "Service",
        meta: {auth: true},
        component: PageService,
    },
    {
        path: "/recomend",
        name: "Recomend",
        meta: {auth: true,},
        component: PageRecomend,
    },
    {
        path: "/recomend-term",
        name: "RecomendTerm",
        meta: {auth: true,},
        component: PageRecomendTerm,
    },
    {
        path: "/recomend-url",
        name: "RecomendUrl",
        meta: {auth: true,},
        component: PageRecomendUrl,
    },
    {
        path: "/autopayment",
        name: "Autopayment",
        meta: {auth: true,},
        component: PageAutopayment,
    },
    {
        path: "/recomend-qrcode",
        name: "RecomendQrcode",
        meta: {auth: true,},
        component: PageRecomendQrcode,
    },
    {
        path: "/recommend",
        name: "Recommend",
        component: PageRecommend,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
});

router.beforeEach((to, from, next) => {
    ensureActiveAccount();
    const requireAuth = to.matched.some(record => record.meta.auth)
    if (!localStorage.token && requireAuth) {
        next('/login')
    } else {
        if (to.name !== "Documents" || localStorage.userType === "legalEntity") {
            next()
        }else {
            next(from.path)
        }
    }
})

export default router;
